<template>
  <v-container fill-height>
    <v-row>
      <v-col>
        <div class="about">
          <p>
            即係咁，應該唔只我一個覺得天文台廢。但仍然有一樣野廢過天文台，就係天文台個網。
          </p>
          <p>
            由於頂唔順佢個網太難用、太核突、同埋佢句「同心抗疫」，既然佢有開放 API，索性自己寫過一個算。
          </p>
          <p>
            如果你覺得好用，其實可以考慮下課金?
          </p>
          <v-btn class="teal" href="https://ko-fi.com/D1D87PU9U" target="_blank" dark>
            <v-icon class="mr-3">
              mdi-coffee
            </v-icon>
            我要課金
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12">
        <a href="https://blackcityhenry.com" target="_blank">
          Henry Yeung
        </a>
        @2022

      </v-col>

    </v-row>
  </v-container>
</template>

<script>
export default {

}
</script>

<style lang="scss">
</style>
